import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { cloudStorage } from '@telegram-apps/sdk-react';
import { MotionValue } from 'framer-motion';

import { CandidateUI } from '@/api/matchmaker/types.ts';
import PremiumUpsaleCard from '@/components/Discovery/Card/PremiumUpsaleCard.tsx';
import { SwipeRef } from '@/components/Discovery/Discovery.tsx';
import { CustomDiscoveryCardHids } from '@/enums/viewEnums.ts';
import { CustomDiscoveryCardCloudKeys } from '@/enums/storageEnums.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

export interface BaseCustomCardProps {
  isFrontCard: boolean;
  sharedX: MotionValue<number>;
}

interface CustomCardConfig<
  T extends BaseCustomCardProps = BaseCustomCardProps
> {
  hid: string;
  createPlaceholder: () => CandidateUI;
  component: ForwardRefExoticComponent<T & RefAttributes<SwipeRef>>;
  insertCondition: (candidates: CandidateUI[]) => Promise<boolean>;
  insertPosition: (candidates: CandidateUI[]) => number;
}

export const customCardsConfig: CustomCardConfig[] = [
  {
    hid: CustomDiscoveryCardHids.PREMIUM_UPSALE,
    createPlaceholder: () =>
      ({
        profile: { hid: CustomDiscoveryCardHids.PREMIUM_UPSALE }
      }) as CandidateUI,
    component: PremiumUpsaleCard,
    insertCondition: async (candidates) => {
      const { premium } = useProfileStore.getState();

      if (candidates.length < 3 || !premium.isExpired) return false; // Require at least 3 candidates

      try {
        const lastInsertTime = await cloudStorage.getItem(
          CustomDiscoveryCardCloudKeys.PREMIUM_UPSALE_KEY
        );
        const now = Date.now();
        const showCooldown = 72 * 60 * 60 * 1000;
        return (
          !lastInsertTime || now - parseInt(lastInsertTime, 10) >= showCooldown
        );
      } catch (e) {
        return false;
      }
    },
    insertPosition: (candidates) => candidates.length - 2 // Third-to-last position
  }
];

export const isCustomCard = (hid: string): boolean =>
  customCardsConfig.some((config) => config.hid === hid);
